<!-- vue2模版 -->
<template>
  <div class="banner">
    <div v-html="content" />
  </div>
</template>
<script>
import { getCMSBanner } from '@/api/cms'
import { getQueryString } from '@/common/tools'
export default {
  name: 'Banner',
  data () {
    return {
      name: '',
      img: '',
      content: ''
    }
  },
  mounted () {
    const id = getQueryString('id')
    if (id) {
      this.getCMSBanner(id)
    }
  },
  methods: {
    async getCMSBanner (id) {
      try {
        const { data } = await getCMSBanner({ id })
        this.name = data.name
        // 修改页面标签title
        document.title = data.name || '搜机网'
        this.img = data.img
        this.content = data.content
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.banner {
  padding: 16px calc(24px + env(safe-area-inset-right)) 16px calc(24px + env(safe-area-inset-left));
  max-width: 100%;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  box-sizing: border-box;
  ::v-deep p {
    margin-bottom: 12px;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
  }
  ::v-deep b {
    font-weight: 600;
  }
}
</style>
